
const LoginImg = () => {
  return (
    <div className='loginimg_container' style={{borderRight:"1px solid #29292941",flexDirection:"column", alignItems:'flex-start', paddingLeft:"100px"}}>
        <h1 style={{fontWeight:"700", fontSize:"54px", color:"#fff"}}>Welcome Back,<br/> Mentor!</h1>
        <p style={{color:"white", fontSize:"18px"}}>Login in and continue your journey with your students.</p>
    </div>
  )
}

export default LoginImg